/*
 * Takes one value in seconds and returns it with either
 * 'm' or 'h' after it.
 */
export function formatDuration(valueAsSeconds?: Nullable<number>, emptyValue = ''): string {
  if (!valueAsSeconds) return emptyValue
  const valueAsMinutes = valueAsSeconds / 60

  if (valueAsMinutes < 1) return '<1m'
  if (valueAsMinutes < 60) return `${Math.round(valueAsMinutes)}m`
  return `${(valueAsMinutes / 60).toFixed(1)}h`
}
